import React, { useState, useContext, createContext } from "react";
import axios from 'axios';

const authContext = createContext();

function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return (
        <authContext.Provider value={auth}>
            {children}
        </authContext.Provider>
    );
}

const standardAuth = {
    isAuthenticated: false,
    ping() {
        return axios.get('api/auth', {}, { withCredentials: true })
            .then(response => { standardAuth.isAuthenticated = true; return response.data; })
            .catch(response => { standardAuth.isAuthenticated = false; return response; });
    },
    signin(username, password) {
        return axios.post('api/auth/login', { username: username, password: password }, { withCredentials: true })
            .then(response => {
                standardAuth.isAuthenticated = true;
                return response.data;
            });
    },
    signout() {
        return axios.post('api/auth/logout', {}, { withCredentials: true })
            .then(response => { standardAuth.isAuthenticated = false; return response; });
    },
    initSSO: (returnUrl) => {
        return axios.post('api/auth/sso?returnUrl=' + encodeURIComponent(returnUrl), {}, { withCredentials: true });
    },
};

function useAuth() {
    return useContext(authContext);
}

function useProvideAuth() {
    const updateUser = (u) => {
        setUser(() => {
            var toStore = Object.assign({}, u);
            delete toStore.updateUser;
            localStorage.setItem("lthub_user", JSON.stringify(toStore));
            toStore.updateUser = updateUser;
            return toStore;
        });
    };

    const initSSO = (returnURL) => {
        return standardAuth.initSSO(returnURL).then(response => {
            window.location.href = response.data;
            return response.data;
        });
    };

    const [user, setUser] = useState({ "updateUser": updateUser, "id": 0 });
    const [loading, setLoading] = useState(false);

    const [init, setInit] = useState(true);
    var restoreUser = function () {
        var stored = localStorage.getItem("lthub_user");
        updateUser(stored ? JSON.parse(stored) : null);
        setInit(false);
    };

    const signin = (username, password) => {
        setLoading(true);
        return standardAuth.signin(username, password).then(response => { window.localStorage.setItem("lthub_has_loggedin", "1"); setLoading(false); updateUser(response.user); return response; });
    };

    const signout = (soft = false) => {
        if (soft) {
            standardAuth.isAuthenticated = false;
            updateUser({ id: 0 });
            return Promise.resolve();
        } else {
            return standardAuth.signout().then(response => {
                updateUser({ id: 0 });
                standardAuth.isAuthenticated = false;
                return response;
            });
        }
    };

    const ping = () => {
        setLoading(true);
        return standardAuth.ping()
            .then(response => {
                if (response.message === "yes") {
                    window.localStorage.setItem("lthub_has_loggedin", "1");
                    updateUser(response.user);
                    setLoading(false);
                    return response.message;
                } else {
                    signout(true);
                }
                setLoading(false);
            })
            .catch(response => {
                signout(true);
                setLoading(false); });
    };


    if (init) {
        const response = restoreUser();
        if(!response?.user)
            setLoading(true);
        setTimeout(() => {
            ping();
        }, 2000);
    }

    return {
        initSSO,
        user,
        signin,
        signout,
        ping,
        loading
    };
}

export default useAuth;
export { ProvideAuth };